<template>
    <div>
      <!-- 面包屑导航 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>站点管理</el-breadcrumb-item>
      </el-breadcrumb>
      <!-- 搜索筛选 -->
      <el-form :inline="true" class="user-search">
  
  
  
  
        <!-- <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="selectSlideshow()">查询</el-button>
        </el-form-item> -->
  
        <el-form-item label="">
  
          <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
        </el-form-item>
      </el-form>
      <!--列表-->
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column align="center" type="selection" width="60">
        </el-table-column>
        <el-table-column prop="name" label="店铺主图" width="120"> 
  
          <template slot-scope="scope">
            <img  style="width: 90px;height: 90px;" :src="scope.row.station_image">
          </template>
  
        </el-table-column>
        <el-table-column sortable prop="station_name" label="店铺名称" width="100">
        </el-table-column>
        <el-table-column sortable prop="station_site" label="店铺地址" width="200">
        </el-table-column>
        <el-table-column sortable prop="telephone" label="店铺电话" width="150">
        </el-table-column>
        <el-table-column sortable prop="introduce" label="店铺介绍" width="200">
        </el-table-column>
        <el-table-column sortable prop="latitude" label="经度" width="100">
        </el-table-column>
        <el-table-column sortable prop="longitude" label="纬度" width="100">
        </el-table-column>
     

  
        <el-table-column align="center" label="操作" min-width="300">
          <template slot-scope="scope">
  
 
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="deleteStation(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <!-- 编辑界面 -->


 

      <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
        <el-form label-width="120px"   ref="editForm">
          <el-form-item label="店铺名称" prop="deptName">
            <el-input size="small" v-model="formData.station_name" auto-complete="off" placeholder="请填写"></el-input>
          </el-form-item>
  
          <el-form-item label="店铺主图" style="">
  
              <div class="upload-demo">
                    <el-upload
                    action=""
                    :http-request="mainImgUpload"
                    :show-file-list="false"
                    list-type="picture-card" >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <img v-if="formData.station_image" :src="formData.station_image" class="avatar">
       
              </div>
                  
          </el-form-item>  
          <el-form-item label="店铺地址" prop="deptName">
            <el-input size="small" v-model="formData.station_site" auto-complete="off" placeholder="请填写"></el-input>
          </el-form-item>
          <el-form-item label="店铺电话" prop="deptName">
            <el-input size="small" v-model="formData.telephone" auto-complete="off" placeholder="请填写"></el-input>
          </el-form-item>
          <el-form-item label="店铺介绍" prop="deptName">
            <el-input size="small" v-model="formData.introduce" auto-complete="off" placeholder="请填写"></el-input>
          </el-form-item>
          <el-form-item label="经度" prop="deptName">
            <el-input size="small" v-model="formData.latitude" auto-complete="off" placeholder="请填写"></el-input>
          </el-form-item>
          <el-form-item label="纬度" prop="deptName">
            <el-input size="small" v-model="formData.longitude" auto-complete="off" placeholder="请填写"></el-input>
          </el-form-item>
  
  
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="closeDialog">取消</el-button>
          <el-button size="small" type="primary" :loading="loading" class="title" @click="addStation()" v-if="title=='添加'">添加</el-button>
          <el-button size="small" type="primary" :loading="loading" class="title" @click="upStation()" v-if="title=='修改'">修改</el-button>
        </div>
      </el-dialog>
    </div>
  </template>
  
  <script>
  import {
  
    addDishes,
  
  
    
    addStation,
    upStation,
    deleteStation,
    getStationList,
    
    
  
  } from "../../api/userMG";
  import Pagination from "../../components/Pagination";
  import client from "@/utils/ossClient.js";
  export default {
    data() {
      return {
        type:0,

  
        nshow: true, //switch开启
        fshow: false, //switch关闭
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        title: "添加",
  
        listData: [], //
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 20,
          total: 10,
        },
  
  
        formData: {
  
          station_name:"",//站点名称
          station_site:"",//地址
          station_image:"",//图片
          telephone:"",//电话
          introduce:"",//介绍
          latitude:"",//经纬度
          longitude:"",//经纬度
          



        },
      };
    },
    // 注册组件
    components: {
      Pagination,
    },
    /**
     * 数据发生改变
     */
  
    /**
     * 创建完毕
     */
    created() {
      // this.getStationList()
  
    },
  
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
          // 删除
          deleteStation(index, row) {
        this.$confirm("确定要删除吗?", "信息", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            deleteStation({ id: row.id })
              .then((res) => {
                if (res.code == 200) {
                  this.$message({
                    type: "success",
                    message: "已删除！",
                  });
                  this.getStationList();
                } else {
                  this.$message({
                    type: "info",
                    message: res.msg,
                  });
                }
              })
              .catch((err) => {
                this.loading = false;
                this.$message.error("删除失败，请稍后再试！");
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      },
  
          //
          upStation  () {
  
        this.loading = true;
        var formData = JSON.parse(JSON.stringify(this.formData));
  
  
        upStation(formData).then((res) => {
          this.loading = false;
          if (res.code == 200) {
            this.editFormVisible=false
            this.$message({
              type: "success",
              message: res.msg,
            });
            this.getStationList();
          } else {
            this.$message.error(res.msg);
          }
        });
      },
  
      //
      addStation() {
  
        this.loading = true;
        this.formData.type = this.type;
  
        var formData = JSON.parse(JSON.stringify(this.formData))
  
  
        
  
        addStation(this.formData).then((res) => {
          this.loading = false;
          if (res.code == 200) {
            this.editFormVisible=false
            this.$message({
              type: "success",
              message: res.msg,
            });
            this.getStationList();
          } else {
            this.$message.error(res.msg);
          }
        });
      },
  
      //自定义上传方法..
      mainImgUpload(file) {
  
        //判断扩展名
        const tmpcnt = file.file.name.lastIndexOf(".");
        const exname = file.file.name.substring(tmpcnt + 1);
        const names = ["jpg", "jpeg", "webp", "png", "bmp"];
        if (names.indexOf(exname) < 0) {
          this.$message.error("不支持的格式!");
          return;
        }
        const fileName = file.file.uid + "." + exname;
        client
          .put(fileName, file.file)
          .then((res) => {
            if (res.url) {
              this.formData.station_image = res.url;
            } else {
              this.$message.error("文件上传失败");
            }
          })
          .catch((err) => {});
      },
  
  
      // 获取轮播图
      getStationList() {
        this.loading = true;
  
        getStationList({type:this.type}).then((res) => {
          this.loading = false;
          if (res.code == 200) {
            this.listData = res.data.list;
            return;
          }
          this.$message({
            type: "info",
            message: res.msg,
          });
        });
      },
  
      // 分页插件事件
      callFather(parm) {
        this.getDishesList(parm.currentPage);
      },
  
      //显示编辑界面
      handleEdit: function (index, row) {
        this.editFormVisible = true;
        if (row != undefined && row != "undefined") {
          this.title = "修改";
          this.formData.id = row.id;
          this.formData.station_image = row.station_image;
          this.formData.station_name = row.station_name;
          this.formData.station_site = row.station_site;
          this.formData.telephone = row.telephone;
          this.formData.introduce = row.introduce;
          this.formData.latitude = row.latitude;
          this.formData.longitude = row.longitude;


  
        } else {
          this.title = "添加";
          this.formData.id = "";
          this.formData.station_image = "";
          this.formData.station_name = "";
          this.formData.station_site = "";
          this.formData.telephone = "";
          this.formData.introduce = "";
          this.formData.latitude = "";
          this.formData.longitude = "";

        }
      },
  
      // 关闭编辑、增加弹出框
      closeDialog() {
        this.editFormVisible = false;
      },
    },
  };
  </script>
  
  <style scoped>
  .user-search {
    margin-top: 20px;
  }
  .userRole {
    width: 100%;
  }
  .upload-demo {
    display: flex;
    flex-direction: row;
  }
  
  .upload-demo img {
    width: 140px;
    height: 140px;
  }
  </style>
  
   
   


// WEBPACK FOOTER //
// src/views/terrace/Valuation.vue